<template>
    <div>
        <h1>这是表格封装演示</h1>
        <Tables :tableData="tableDatas"></Tables>
    </div>
</template>

<script>
import Tables from '@/components/Tables'
let list1 = [
    {
        name: 'oppo',
        todayBuy: 100,
        monthBuy: 3000000000000,
        totalBuy: 800
    }, {
        name: 'vivo',
        todayBuy: 100,
        monthBuy: 300,
        totalBuy: 800
    }, {
        name: '苹果',
        todayBuy: 100,
        monthBuy: 300,
        totalBuy: 800
    }, {
        name: '小米',
        todayBuy: 100,
        monthBuy: 300,
        totalBuy: 800
    }, {
        name: '三星',
        todayBuy: 100,
        monthBuy: 300,
        totalBuy: 800
    }, {
        name: '魅族',
        todayBuy: 100,
        monthBuy: 300,
        totalBuy: 800
    }
]
export default {
    name: "",
    data () {
        return {
            tableDatas: {}
        }
    },
    components: {
        Tables
    },
    methods: {
        getTableData() {
            this.tableDatas['tablelist'] = list1

            this.tableDatas['columns'] = [
                {
                    label: '课程',
                    prop: 'name'
                },
                {
                    label: '今日购买',
                    prop: 'todayBuy'
                },
                {
                    label: '本月购买',
                    prop: 'monthBuy'
                },
                {
                    label: '总购买',
                    prop: 'totalBuy'
                }
            ]
            this.tableDatas['total'] = 6
            this.tableDatas['queryInfo'] = {
                pagenum: 1,
                pagesize: 10
            }
            console.log(this.tableDatas)
        }
    },
    mounted () {
        this.getTableData()
    }
}
</script>

<style scoped>

</style>
